import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number = 30) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          return initialMinutes * 60 // Reset to initial
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [initialMinutes])

  const minutes = Math.floor(timeLeft / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (timeLeft % 60).toString().padStart(2, '0')

  return { minutes, seconds }
}
